
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'VWindicators',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/VWindicators.vue